import dayjs, { Dayjs } from 'shared/dayjs'
import { ManageEventDetailDayjs } from 'front-end/src/pages/manage-events/event-edit/EventEditPage'
import { isIE, isSSR } from 'front-end/../shared/helpers'

interface ConvertDBTimeToUTCPayload {
  date?: string | null
  timezone?: string | null
}

interface ConvertUTCToDBTimePayload {
  date?: Dayjs | null
  timezone: string
}

export const DATE_FORMAT_FOR_SHIFT = 'YYYY-MM-DD HH:mm'

// Should convert back to utc before save
export const prepareEventForUpdate = (
  event: Partial<ManageEventDetailDayjs>
) => {
  const startTime = getUTCDateFromTimeZoneDate({
    date: event.start_time,
    timezone: event.timezone as string
  })
  const endTime = getUTCDateFromTimeZoneDate({
    date: event.end_time,
    timezone: event.timezone as string
  })

  return {
    ...event,
    start_time: startTime,
    end_time: endTime,
    updated_at: new Date().toISOString()
  }
}

export const getTimeZoneDateFromUTCDate = ({
  date,
  timezone
}: ConvertDBTimeToUTCPayload) => {
  if (!date) return null

  let dateDayjs = dayjs.utc(date)

  if (timezone) {
    const shiftedTimeString = isIE
      ? dateDayjs.format(DATE_FORMAT_FOR_SHIFT)
      : dateDayjs.tz(timezone).format(DATE_FORMAT_FOR_SHIFT)

    dateDayjs = dayjs.utc(shiftedTimeString, DATE_FORMAT_FOR_SHIFT)
  }

  return dateDayjs
}

export const getUTCDateFromTimeZoneDate = ({
  date,
  timezone
}: ConvertUTCToDBTimePayload) => {
  if (!date) return null

  const startTimeShifted =
    isIE && !isSSR
      ? dayjs(date?.format(DATE_FORMAT_FOR_SHIFT))
      : dayjs.tz(date?.format(DATE_FORMAT_FOR_SHIFT), timezone)

  return startTimeShifted.isUTC()
    ? startTimeShifted.toISOString()
    : startTimeShifted.utc().toISOString()
}

export const getDefaultEventTime = () => {
  const addition = dayjs().minute() < 30 ? 0.5 : 1

  const defaultStartTime = getUTCDateFromTimeZoneDate({
    date: dayjs().startOf('hour').add(addition, 'hour'),
    timezone: dayjs.tz.guess()
  })
  const defaultEndTime = getUTCDateFromTimeZoneDate({
    date: dayjs()
      .startOf('hour')
      .add(addition + 1, 'hour'),
    timezone: dayjs.tz.guess()
  })

  return { defaultStartTime, defaultEndTime }
}
